import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./NavBar.scss";
import logo from "../../Images/Gemini.png";

export default function NavBar({ isWhite }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleScroll = () => setIsScrolled(window.scrollY > 10);

  const handleLinkClick = () => setIsMenuOpen(false);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`navbar-container ${isWhite || isScrolled ? "scrolled" : ""}`}>
      <nav className="navbar">
        {/* LOGO — LEFT */}
        <div className="logo">
          <Link to="/" onClick={handleLinkClick}>
            <img src={logo} alt="Tamatrettours Logo" />
          </Link>
        </div>

        {/* LINKS — TRUE CENTER */}
        <div className={`navbar-links ${isMenuOpen ? "open" : ""}`}>
          <Link to="/" onClick={handleLinkClick}>Home</Link>
          <Link to="/about" onClick={handleLinkClick}>About</Link>
          <Link to="/tours" onClick={handleLinkClick}>All Tours</Link>
          <Link to="/reviews" onClick={handleLinkClick}>Reviews</Link>
          <Link to="/contact" onClick={handleLinkClick}>Contact</Link>
        </div>

        {/* MENU ICON — RIGHT (MOBILE) */}
        <div className="menu-icon" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>
    </header>
  );
}
